import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-image',
  templateUrl: './modal-image.component.html',
  styleUrls: ['./modal-image.component.scss'],
})
export class ModalImageComponent {
  modalService = inject(NgbActiveModal);

  openRegisterForm() {
    window.open(
      'https://docs.google.com/forms/d/e/1FAIpQLSd6ALh5OuLMCE6D0FBPe0aDMNGwzfUIJu519Bn9RuCD5y71Uw/viewform',
      '_blank',
    );
  }
}
